import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { apiKeyHeader } from "../../../configs/ApiKeys";
import {
  createEventActivity,
  createTask,
  getActivityDetails,
  GetActivityTasks,
  getEvents,
  getPublishedDocuments,
  MapCostSheetActivity,
  updateAssignedUser,
  updateStatus,
  updateTaskstatus,
  userRole,
  WsGetCostSheets,
  WSGetOrgUsers,
  WsPutCostSheet,
} from "../../../configs/WebService";
import axios from "axios";
import moment from "moment";
import userStore from "../../../zustand/userStore";

export const fetchOrganiserEvents = createAsyncThunk(
  "eventOrganiser/fetchEvents",
  async ({ userId }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${getEvents}/${userId}`, {
        headers: apiKeyHeader(),
      });

      return response.data;
    } catch (error) {
      toast.error(error.message || "Failed to fetch events");
      return rejectWithValue(error.message);
    }
  }
);

export const fetchCostSheets = createAsyncThunk(
  "costSheet/fetchCostSheets",
  async ({ orgId, userId }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${WsGetCostSheets}/${orgId}/${userId}`, {
        headers: apiKeyHeader(),
      });

      const data = response.data;

      if (data.resultCode === 1) {
        return data.resultMessage;
      } else {
        return rejectWithValue(data.resultMessage);
      }
    } catch (error) {
      toast.error("Error while getting data");
      return rejectWithValue("Error while getting data");
    }
  }
);

export const createCostSheet = createAsyncThunk(
  "costSheet/createCostSheet",
  async ({ body, activityId }, { rejectWithValue, dispatch }) => {
    console.log("activityId", activityId);
    try {
      const response = await axios.post(WsPutCostSheet, body, {
        headers: apiKeyHeader(),
      });

      const data = response.data;

      if (data.resultCode === 1) {
        // toast.success("Cost Sheet Created");

        await dispatch(
          mapCostSheetActivity({
            activityId,
            costSheetId: data.resultMessage.costSheetId,
            userId: body.userId,
            // orgId: body.orgId,
          })
        );

        return data.resultMessage;
      } else {
        toast.error(data.resultMessage || "Failed to create cost sheet");
        return rejectWithValue(data.resultMessage);
      }
    } catch (error) {
      toast.error(error.message || "Error while creating cost sheet");
      return rejectWithValue(error.message);
    }
  }
);

export const mapCostSheetActivity = createAsyncThunk(
  "costSheet/mapCostSheetActivity",
  async ({ activityId, costSheetId, userId, orgId }, { rejectWithValue }) => {
    try {
      const body = {
        activityId: activityId,
        costSheetId: costSheetId,
        userId: userId,
        orgId: orgId,
      };

      const response = await axios.post(MapCostSheetActivity, body, {
        headers: apiKeyHeader(),
      });

      const data = response.data;

      if (data.message === "Mapped Successfully!") {
        toast.success("Cost Sheet mapped to activity successfully");
        return data.resultMessage;
      } else {
        return rejectWithValue(data.resultMessage);
      }
    } catch (error) {
      toast.error(error.message || "Failed to map cost sheet to activity");
      return rejectWithValue(error.message);
    }
  }
);

export const GetActivityDetailsThunk = createAsyncThunk(
  "eventOrganiser/getActivityDetails",
  async ({ activityId }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(`${getActivityDetails}/${activityId}`, {
        headers: apiKeyHeader(),
      });

      const data = await response.data;

      dispatch(fetchChecklist(activityId));
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateCostSheetStatus = createAsyncThunk(
  "costSheet/updateStatus",
  async ({ id, status, userId, orgId }, { dispatch, rejectWithValue }) => {
    const body = {
      id: id,
      status: status,
    };
    try {
      const response = await axios.post(updateStatus, body, {
        headers: apiKeyHeader(),
      });

      if (response.data.message === "Cost Sheet Status Updated!") {
        // dispatch(fetchCostSheets({ orgId, userId }));
        toast.success("Status updated successfully");
        return response.data;
      } else {
        toast.error(response.data.resultMessage || "Failed to update status");
        return rejectWithValue(response.data.resultMessage);
      }
    } catch (error) {
      toast.error("Error updating status");
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const submitEvent = createAsyncThunk(
  "event/submitEvent",
  async ({ formData, userData }, { rejectWithValue }) => {
    try {
      const formattedDate = moment(formData.date).format("DD-MM-YYYY");
      const body = {
        // orgId: userData.org.id,
        userId: userData.id,
        name: formData.eventName,
        date: formattedDate,
        startTime: formData.startTime,
        endTime: formData.endTime,
        activities: formData.activities,
      };

      const response = await axios.post(createEventActivity, body, {
        headers: apiKeyHeader(),
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const submitTask = createAsyncThunk(
  "task/submitTask",
  async ({ TaskData }, { rejectWithValue }) => {
    // const orgId = userStore.getState()?.user?.org?.id;
    const userId = userStore.getState()?.user?.id;

    try {
      const response = await axios.post(`${createTask}/${userId}`, TaskData, {
        headers: apiKeyHeader(),
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const fetchChecklist = createAsyncThunk(
  "task/fetchChecklist",
  async (activity_id, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${GetActivityTasks}/${activity_id}`, {
        headers: apiKeyHeader(),
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const fetchOrgUsers = createAsyncThunk(
  "users/fetchOrgUsers",
  async (_, { rejectWithValue }) => {
    const userId = userStore.getState()?.user?.id;
    try {
      const res = await axios.get(`${WSGetOrgUsers}/${userId}`, {
        headers: apiKeyHeader(),
      });
      return res?.data || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const updateAssignedUsers = createAsyncThunk(
  "eventOrganiser/updateAssignedUsers",
  async ({ taskId, assignedUsers }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${updateAssignedUser}/${taskId}`,
        { assigned_users: assignedUsers },
        { headers: apiKeyHeader() }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const updateTaskStatus = createAsyncThunk(
  "eventOrg/updateTaskStatus",
  async ({ taskId, status }) => {
    const response = await axios.put(`${updateTaskstatus}`, { taskId, status }, { headers: apiKeyHeader() });
    const data = response?.data;
    if (!response || response.status < 200 || response.status >= 300) throw new Error(data?.message || "Failed to update status");
    return data;
  }
);
export const getDocumentsDataThunk = createAsyncThunk(
  "Organiser/getDocumentsDataThunk",
  async ({ userId, orgId }, thunkAPI) => {
    try {
      const response = await axios.get(` https://web1024.docmaster.in:8443/organisation/getAllDocForm/${userId}/${orgId}`, { headers: apiKeyHeader()});
      const data = response?.data;
      if (data?.result_code === 1) {
        return data.result_message;
      } else {
        alert(data.result_message);
      }
      console.log(data, "documents data");
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
export const GetUserRoleThunk = createAsyncThunk(
  "CaseDiaryOrg/GetUserRoleThunk",
  async ({ userId, orgId }, thunkAPI) => {
    try {
      const response = await axios.get(`${userRole}/${userId}/${orgId}`, { headers: apiKeyHeader()});
      const data = response?.data;
      if (!response || response.status < 200 || response.status >= 300) {
        throw new Error(data?.message || "Error fetching user role data");
      }
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const getDocumentsData = createAsyncThunk(
  "documents/getDocumentsData",
  async ({ type, categoryIds }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        getPublishedDocuments,
        { type, categoryIds },
        { headers: apiKeyHeader() }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
